import React from 'react';
import {Container} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import OneBook from "../components/getbook";
import logoimg from "../img/square.png";
import {Helmet} from "react-helmet-async";

function Book() {
    const { id,chapter } = useParams();
    return (
        <div>
            <Helmet>
                <title>World by Mau</title>
                <meta property="og:title" content="World By Mau" />
                <meta property="og:image" content={logoimg} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="World By Mau" />
                <meta name="twitter:image" content={logoimg} />
            </Helmet>
            <div className="me-auto content-read">
                <OneBook id={id}/>
            </div>
        </div>);
}

export default Book;
